var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconEraser = function SvgIconEraser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m7.795 8.706-5.218 5.218-.002.002a2.49 2.49 0 0 0 0 3.536l.002.002 3.475 3.474a1 1 0 0 0 .707.293h13.49a1 1 0 1 0 0-2h-7.427l8.134-8.127.007-.006a2.52 2.52 0 0 0 0-3.53l-.007-.007-4.243-4.233-.002-.003a2.49 2.49 0 0 0-3.536 0l-.002.003-5.217 5.217a1 1 0 0 0-.16.161m6.96-4.079a.49.49 0 0 1 .537.108l.004.004 4.243 4.233a.52.52 0 0 1 0 .722l-4.593 4.588-4.95-4.95 4.595-4.594.004-.003a.5.5 0 0 1 .16-.108m-6.172 6.12 4.948 4.948-3.54 3.536H7.174l-3.185-3.185-.004-.003a.49.49 0 0 1 0-.698l.004-.003z",
    clipRule: "evenodd"
  })));
};
export default SvgIconEraser;